import { render, staticRenderFns } from "./MainNavigationBar.vue?vue&type=template&id=8cfb7ad2&scoped=true&"
import script from "./MainNavigationBar.vue?vue&type=script&lang=js&"
export * from "./MainNavigationBar.vue?vue&type=script&lang=js&"
import style0 from "./MainNavigationBar.vue?vue&type=style&index=0&id=8cfb7ad2&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cfb7ad2",
  null
  
)

export default component.exports